// extracted by mini-css-extract-plugin
export default {"header":"Header_header__DuY+F","section":"Header_section__UY069"};